const orderCapture = {
  namespaced: true,
  state: {
    filters: {
      currentTab: 'SPOT',
      'CONTRACT': {
        customer: null,
        products: [],
        terminal: null,
        networks: [],
        routePath: '/OrderCapture/contracts'
      },
      'SPOT': {
        customer: null,
        products: [],
        terminal: null,
        networks: [],
        routePath: '/OrderCapture/spot'
      }
    },
  },
  getters:{
    getCurrentTab(state){
      return state.filters.currentTab;
    },
    getRoutePath(state){
      return state.filters[`${state.filters.currentTab}`].routePath;
    },
    getCustomer(state){
      return state.filters[`${state.filters.currentTab}`].customer;
    },
    getProducts(state){
      return state.filters[`${state.filters.currentTab}`].products;
    },
    getTerminal(state){
      return state.filters[`${state.filters.currentTab}`].terminal;
    },
    getNetworks(state){
      return state.filters[`${state.filters.currentTab}`].networks;
    },
    isNetworkSelected(state){
      return state.filters[`${state.filters.currentTab}`].networks.length > 0;
    },
    isContract(state){
      return state.filters.currentTab === 'CONTRACT';
    },
    getSearchableBool(state){
      return (
        state.filters[`${state.filters.currentTab}`].products.length > 0 &&
        state.filters[`${state.filters.currentTab}`].customer != null &&
        (state.filters[`${state.filters.currentTab}`].terminal != null ||
          state.filters[`${state.filters.currentTab}`].networks.length > 0)
      );
    }
  },
  mutations: {
    SET_CUSTOMER: (state, payload) => {
      state.filters[`${state.filters.currentTab}`].customer = payload;
    },
    SET_PRODUCTS: (state, payload) => {
      state.filters[`${state.filters.currentTab}`].products = payload;
    },
    SET_TERMINAL: (state, payload) => {
      if(payload === {}){
        state.filters[`${state.filters.currentTab}`].terminal = null;
      } else {
        state.filters[`${state.filters.currentTab}`].terminal = payload;
      }
    },
    SET_NETWORKS: (state, payload) => {
      state.filters[`${state.filters.currentTab}`].networks = payload;
    },
    SET_CURRENT_TAB: (state, payload) => {
      state.filters.currentTab = payload;
    },
    RESET_FILTERS: (state) => {
      state.filters[`${state.filters.currentTab}`].customer = null;
      state.filters[`${state.filters.currentTab}`].terminal = null;
      state.filters[`${state.filters.currentTab}`].products = [];
      state.filters[`${state.filters.currentTab}`].networks = [];
    },
  },
  actions: {
    setCustomer: ({ commit }, payload) => {
      commit("SET_CUSTOMER", payload);
    },
    setProducts: ({ commit }, payload) => {
      commit("SET_PRODUCTS", payload);
    },
    setAllSpotProducts: ({ commit, rootGetters }) => {
      const spotFuels = rootGetters["fuelsType/getSpotFuels"];
      commit("SET_PRODUCTS", spotFuels);
    },
    setTerminal: ({ commit }, payload) => {
      commit("SET_TERMINAL", payload);
    },
    setNetworks: ({ commit }, payload) => {
      commit("SET_NETWORKS", payload);
    },
    setCurrentTab: ({ commit }, payload) => {
      commit("SET_CURRENT_TAB", payload);
    },
  }
}

export default orderCapture